import React from 'react';
import Designer from '../images/designer.svg'
import Frontend from '../images/frontend.svg'
import Android from '../images/android.svg'


const Skills = () => {
    return(
        <div className="bg-primary p-1">
        <div className="container1 mt-2 mb-5">
  <section id="skills">
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="card mt-2 mb-3">
          <div class="card-header">
            <img class="skill_imgs" src={Designer} />
            <h3 class="skill_text">Designer</h3>
          </div>
          <div class="card-body">
            <p class="skills_desc">I value simple content structure, clean design patterns, and thoughtful interactions.</p>
            <br />
            <p class="skills_tag">Things I enjoy designing:</p>
            <p class="skills_desc">UX, UI, Web Designs, Graphic Designs</p>
            <br />
            <p class="skills_tag">Design Tools:</p>
            <p class="skills_desc">Figma</p>
            <p class="skills_desc">Corel Draw</p>
            <p class="skills_desc">Photoshop</p>
            <p class="skills_desc">Gimp</p>

            <br />
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="card mt-2 mb-3">
          <div class="card-header">
            <img class="skill_imgs" src={Frontend} />
            <h3 class="skill_text">Full Stack Developer</h3>
          </div>
          <div class="card-body">
            <p class="skills_desc">I like to code things from scratch, and enjoy bringing ideas to life in the browser.</p>
            <br />
            <p class="skills_tag">Technologies & Frameworks I use:</p>
            <p class="skills_desc">React, javaScript, jQuery, MySQL, NodeJs , HTML, CSS</p>
            <br />
            <p class="skills_tag">Dev Tools:</p>
            <p class="skills_desc">VsCode</p>
            <p class="skills_desc">Codepen</p>
            <p class="skills_desc">BootStrap</p>
            <p class="skills_desc">React CodeSandBox</p>
            <br />
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card mt-2 mb-3">
          <div class="card-header">
            <img class="skill_imgs" src={Android} />
            <h3 class="skill_text">Android Developer</h3>
          </div>
          <div class="card-body">
            <p class="skills_desc">I love to develop Android Applications with best user interfaces that attract the users.</p>
            <br />
            <p class="skills_tag">Experiences I draw from:</p>
            <p class="skills_desc">App designs, Java skills</p>
            <br />
            <p class="skills_tag">App Dev Tools and languages:</p>
            <p class="skills_desc">Android Studios</p>
            <p class="skills_desc">Adobe XD</p>
            <p class="skills_desc">Figma</p>
            <p class="skills_desc">XML</p>

            <br />
          </div>
        </div>
      </div>

    </div>
  </section>
        </div>
        </div>
    );
}

export default Skills;